module.exports = __webpack_public_path__ + "img/3.1c32f6e4.png";